<template>
  <DrawerHeader @close="emit('close')">
    Cash Tendered
  </DrawerHeader>
  <div class="flex flex-1 flex-col px-6">
    <div class="mb-4 flex flex-1 flex-col px-8">
      <div class="flex flex-1 items-center justify-center">
        <CustomAmountDisplay :value="amountInput" />
      </div>
      <StatRow
        label="Total Amount Due"
        :value="amountGross"
        type="currency"
        large
      />
      <StatRow
        v-if="!isGratuityEnabled"
        label="Change Due"
        :value="changeDue"
        type="currency"
        large
      />
    </div>

    <BaseNumpad v-model="amountInput" />
  </div>
  <div class="flex items-center justify-center p-4">
    <ActionButtonPrimary
      :disabled="!amountInput"
      class="w-full"
      @click="emit('submit', amountInput)"
    >
      Pay Now
    </ActionButtonPrimary>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
const props = defineProps<{
  amountGross: number
}>()

const emit = defineEmits<{
  (event: "submit", cashTendered: number): void
  (event: "close"): void
}>()

const { isGratuityEnabled } = useTenant()

const amountInput = ref(0)

const changeDue = computed(() =>
  Math.max(0, amountInput.value - props.amountGross)
)
</script>
